export * from './components';
export * from './directives';
export * from './navigation';
export * from './util';
export { ArchwizardModule } from './archwizard.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-archwizard/dist/index.js
// module id = ../../../../ng2-archwizard/dist/index.js
// module chunks = 3